// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__2i-p3","fadeIn":"Button_fadeIn__UD5JK","fadeOut":"Button_fadeOut__37Xut"};